import { sizes } from '@sharefiledev/antd-config';
import {
	type EntitlementsContentParams,
	entitlementsPiletModals,
} from '@sharefiledev/entitlements-pilet-sdk';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Breakpoint, type ModalProps } from 'antd';
import { EntitlementsHttp } from '../api';
import {
	type ActionButton,
	ActionButtonKind,
	type NotificationRequest,
	NotificationType,
	type UserEmailInfo,
} from '../components/types';

export const handleButtonClick = async (
	piletApi: PiletApi,
	entitlementContentParams: EntitlementsContentParams,
	userRID: string,
	userEmailInfo: UserEmailInfo,
	locale: string,
	actionTaken: ActionButtonKind | undefined,
	primaryAction: ActionButton | undefined,
	secondaryAction?: ActionButton,
	notificationTemplateId?: string
): Promise<boolean> => {
	if (!actionTaken || !primaryAction) {
		return false;
	}

	let url: string = window.location.href;
	if (actionTaken === ActionButtonKind.NotifyAdmin) {
		await postNotifyAdminRequest(
			entitlementContentParams.entitlementRID,
			entitlementContentParams.entitlementDefRID,
			userRID,
			userEmailInfo,
			entitlementContentParams.evaluationResult.limit,
			locale,
			primaryAction,
			secondaryAction,
			notificationTemplateId
		);
		return true;
	} else if (actionTaken === ActionButtonKind.ShowModal) {
		piletApi.showModal(
			entitlementsPiletModals.entitlementsModal,
			entitlementContentParams
		);
		return false;
	} else if (actionTaken === primaryAction.kind) {
		url = getUrl(primaryAction.urlPath);
	} else if (actionTaken === secondaryAction?.kind) {
		url = getUrl(secondaryAction.urlPath);
	}

	window.location.assign(url);

	return false;
};

export const postNotifyAdminRequest = async (
	entitlementRID: string,
	entitlementDefRID: string,
	userRID: string,
	userEmailInfo: UserEmailInfo,
	limit: string,
	locale: string,
	primaryAction: ActionButton,
	secondaryAction?: ActionButton,
	notificationTemplateId?: string
) => {
	const primaryLink = getUrl(primaryAction.urlPath) + '&amp;notifyAdmin=true';
	const secondaryLink = !!secondaryAction ? getUrl(secondaryAction.urlPath) : undefined;

	const notificationRequest: NotificationRequest = {
		userRID,
		entitlementRID,
		entitlementDefRID,
		userEmail: userEmailInfo.userEmail,
		userFirstName: userEmailInfo.userFirstName,
		userLastName: userEmailInfo.userLastName,
		notificationType: NotificationType.NotifyAdmin,
		limit,
		actionButtonLink: primaryLink,
		storageButtonLink: secondaryLink,
		notificationTemplateId,
	};
	EntitlementsHttp.sendNotificationRequest(notificationRequest, locale);
};

const getUrl = (path: string): string => {
	return `${window.origin}${path}`;
};

export const getDefaultModalProps: (
	screens?: Partial<Record<Breakpoint, boolean>>
) => Partial<ModalProps> = screens => {
	return {
		centered: true,
		footer: null,
		header: true,
		maskClosable: false,
		width: screens?.lg ? 840 : '100vw',
		height: screens?.lg ? 482 : '80vh',
		styles: {
			content: {
				padding: `${screens?.lg ? sizes.MD : sizes.base} 0 0 0`,
				borderRadius: 12,
			},
		},
	};
};
